const CONSENTS_KEY = "client_consents";
export default class ConsentsStoreManager {
    constructor(data) {
        this.data = data;
    }
    store() {
        const consentsData = {
            tosAgreement: this.data.fields.tosAgreement.value,
            subscribeEmail: this.data.fields.subscribeEmail.value,
            subscribePhone: this.data.fields.subscribePhone.value,
        };
        const consentsDataString = JSON.stringify(consentsData);
        localStorage.setItem(CONSENTS_KEY, consentsDataString);
    }
    restore() {
        const consentsDataString = localStorage.getItem(CONSENTS_KEY);
        if (consentsDataString === null) {
            return;
        }
        const consentsData = JSON.parse(consentsDataString);
        this.data.fields.tosAgreement.onChange(consentsData.tosAgreement);
        this.data.fields.subscribeEmail.onChange(consentsData.subscribeEmail);
        this.data.fields.subscribePhone.onChange(consentsData.subscribePhone);
    }
}
